export enum OwnershipType {
  Owned = 'Owned',
  Leased = 'Leased',
  ThirdParty = 'Third Party',
}
